namespace AgerLMS.CMS {
    export interface SlideRow {
        SlideId?: number;
        SliderId?: number;
        Picture1?: string;
        Picture1Meta?: string;
        Header1?: string;
        Description1?: string;
        Description2?: string;
        Link1Text?: string;
        Link1Href?: string;
        Link2Text?: string;
        Link2Href?: string;
        SlideType?: SlideTypes;
        DisplayOrder?: number;
        SliderSliderName?: string;
        InsertUserId?: number;
        InsertDate?: string;
        InsertUserDisplayName?: string;
    }

    export namespace SlideRow {
        export const idProperty = 'SlideId';
        export const nameProperty = 'Header1';
        export const localTextPrefix = 'CMS.Slide';
        export const deletePermission = 'LMS:CmsPage:Modify';
        export const insertPermission = 'LMS:CmsPage:Modify';
        export const readPermission = 'CMS:Slider:Read';
        export const updatePermission = 'LMS:CmsPage:Modify';

        export declare const enum Fields {
            SlideId = "SlideId",
            SliderId = "SliderId",
            Picture1 = "Picture1",
            Picture1Meta = "Picture1Meta",
            Header1 = "Header1",
            Description1 = "Description1",
            Description2 = "Description2",
            Link1Text = "Link1Text",
            Link1Href = "Link1Href",
            Link2Text = "Link2Text",
            Link2Href = "Link2Href",
            SlideType = "SlideType",
            DisplayOrder = "DisplayOrder",
            SliderSliderName = "SliderSliderName",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
